import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

const scoreBase = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  outline: vars.borders.outline,
  borderRadius: vars.radii.xs,
  backgroundColor: vars.colors.white,
  padding: `${vars.space["2xs"]} ${vars.space.xs}`,
  width: 68,
  color: vars.colors.primaryFixed,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.l,
  fontWeight: 400,
});

export const scoreWrapper = styleVariants({
  default: [scoreBase],
  inProgress: [
    scoreBase,
    {
      backgroundColor: vars.colors.inverseSurface,
      color: vars.colors.inverseOnSurface,
      outline: 0,
    },
  ],
});

export const divider = style({
  margin: `0 ${vars.space.xs}`,
  borderLeft: `1px solid ${vars.colors.onSurfaceVariant}`,
  height: 16,
});
